var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 289,
    viewBox: "0 0 275 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37259 5.37258 0 12 0H263C269.627 0 275 5.37258 275 12V289H0V12Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 145C63 104.131 96.1309 71 137 71C177.869 71 211 104.131 211 145C211 185.869 177.869 219 137 219C96.1309 219 63 185.869 63 145ZM137 100.6C124.739 100.6 114.8 110.539 114.8 122.8C114.8 135.061 124.739 145 137 145C149.261 145 159.2 135.061 159.2 122.8C159.2 110.539 149.261 100.6 137 100.6ZM180.62 185.31L180.833 185.333L180.615 185.32L180.61 185.331L180.598 185.354L180.573 185.404L180.512 185.519C180.467 185.605 180.413 185.703 180.349 185.815C180.223 186.039 180.058 186.316 179.85 186.638C179.436 187.282 178.853 188.108 178.068 189.05C176.493 190.939 174.121 193.281 170.706 195.558C163.809 200.155 153.096 204.2 137.001 204.2C109.731 204.2 98.2646 192.585 94.5723 187.265C92.3383 184.046 92.5856 180.285 93.9369 177.583C99.3862 166.684 110.525 159.8 122.711 159.8H150.055C162.999 159.8 174.832 167.113 180.621 178.691C181.662 180.774 181.662 183.226 180.62 185.31Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPhoto);
export default __webpack_public_path__ + "static/media/DefaultPhoto.825e2a19f779c5bab83837bd7da4d8fc.svg";
export { ForwardRef as ReactComponent };